import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  FiBriefcase,
  FiZap,
  FiCpu,
  FiCode,
  FiCloud,
  FiTrendingUp,
} from "react-icons/fi";
import { aboutSummary, aboutHighlights } from "../data/personalInfo";
import "./About.css";

const iconMap = {
  experience: FiBriefcase,
  performance: FiZap,
  ai: FiCpu,
  wordpress: FiCode,
  cloud: FiCloud,
  scalable: FiTrendingUp,
};

const About = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section id="about" className="about section" ref={ref}>
      <div className="container">
        <motion.div
          className="section__header"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <span className="section__label">About Me</span>
          <h2 className="section__title">
            Building Scalable Solutions That Drive Business Growth
          </h2>
        </motion.div>

        <motion.div
          className="about__content"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {aboutSummary.split("\n\n").map((para, i) => (
            <p key={i} className="about__text">
              {para}
            </p>
          ))}
        </motion.div>

        <div className="about__highlights">
          {aboutHighlights.map((item, i) => {
            const Icon = iconMap[item.icon] || FiCode;
            return (
              <motion.div
                key={i}
                className="about__card"
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.4, delay: 0.3 + i * 0.1 }}
              >
                <div className="about__card-icon">
                  <Icon size={24} />
                </div>
                <h3 className="about__card-title">{item.title}</h3>
                <p className="about__card-desc">{item.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
